import React from 'react'
import { Link } from 'react-router-dom';

const Copyright = () => {
  return (
    <>
      <footer className='bg-body-tertiary py-3 text-center'>
        &copy; Swalok Group. All Rights Reserved. Developed By <Link to='https://dectwinservices.com' target='_blank' className='text-dark text-decoration-none'>Dectwin Services Pvt Ltd</Link>
      </footer>
    </>
  )
}

export default Copyright
